import { useLocalSearchParams } from "expo-router";

import TransactionDetails from "@/src/components/merchant/transaction-details";

export default function TransactionDetailsPage() {
  const { uuid } = useLocalSearchParams<{ uuid: string }>();

  return <TransactionDetails uuid={uuid} />;
}
